import React from 'react';
import { FileContext, FileContextProps } from '../context/FileContext';
import { FileEntity, FileWithSas } from '../types/file';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const fileState = {
  items: new Map<string, FileEntity>(),
  loading: false,
};

export const fileSlice = createSlice({
  name: 'file',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      fileState.items = new Map();
      fileState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<FileEntity[]>) => {
      fileState.items = new Map();
      action.payload.forEach(p => fileState.items.set(p.id, new FileEntity(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<FileEntity[]>) => {
      action.payload.forEach(p => fileState.items.set(p.id, new FileEntity(p)));
      fileState.items = new Map(fileState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<FileEntity[]>) => {
      action.payload.forEach(p => fileState.items.delete(p.id));
      fileState.items = new Map(fileState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      fileState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface FileProviderProps {
  children: React.ReactNode;
}

export default function FileProvider({ children }: FileProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.files.key);

  const fileContext: FileContextProps = {
    fileCache: new Map(),
    setFileCache: (cache: Map<string, FileWithSas>) => {},
    files: fileState.items,
    filesLoading: fileState.loading,
    setFiles: (files: Map<string, FileEntity>) => {
      dispatch(fileSlice.actions.set([...files.values()]));
    },
  };

  return <FileContext.Provider value={fileContext}>{children}</FileContext.Provider>;
}
